import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api.js';

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    const storedUser = localStorage.getItem('user');
    if (token && storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch {
        localStorage.clear();
      }
    }
    setLoading(false);
  }, []);

  const login = useCallback(async (username, password) => {
    const { data } = await api.post('/auth/login', { username, password });
    localStorage.setItem('accessToken', data.accessToken);
    localStorage.setItem('refreshToken', data.refreshToken);
    localStorage.setItem('user', JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    try {
      const refreshToken = localStorage.getItem('refreshToken');
      await api.post('/auth/logout', { refreshToken });
    } catch {
      // ממשיך גם אם השרת לא הגיב
    }
    // העדפות תצוגה (עיצוב חדש / מצב כהה / קיצורים מוצמדים) נשארות אחרי התנתקות
    const keep = Object.keys(localStorage)
      .filter((k) => k.startsWith('bchinot-ui-next') || k.startsWith('bchinot-next-'))
      .map((k) => [k, localStorage.getItem(k)]);
    localStorage.clear();
    keep.forEach(([k, v]) => localStorage.setItem(k, v));
    setUser(null);
  }, []);

  const hasPermission = useCallback(
    (resource, action) => {
      if (!user) return false;
      if (user.roles?.includes('admin')) return true;
      // session ישן לפני שדרוג (אין מערך permissions) — UI פתוח; השרת אוכף
      if (!Object.prototype.hasOwnProperty.call(user, 'permissions')) return true;
      const perms = user.permissions || [];
      const perm = perms.find((p) => p.resource === resource);
      if (!perm) return false;
      return (perm.actions || []).includes(action);
    },
    [user]
  );

  const value = { user, loading, login, logout, hasPermission, isAuthenticated: !!user };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
